import { FC, ReactNode } from 'react';
import FormGroupFrame from '../../../FormGroupFrame/FormGroupFrame';
import { useVisibilityResolve } from '../../../../../hooks/useVisibilityResolve';
import { Group } from '../../../DatasetForm/types';
import { JSONObject } from '../../../../../types/types';

interface SettingsPanelGroupProps {
  group: Pick<Group, 'caption' | 'visible' | 'allowVisible'>;
  resolveData: JSONObject;
  children: ReactNode;
}

// Framed group of panel fields (definition `groups`): resolves the group
// `visible` (boolean | JSONata over resolveData) and hides the whole frame.
// The values of hidden fields stay in the state and keep being saved — same
// rule as dataset forms.
const SettingsPanelGroup: FC<SettingsPanelGroupProps> = ({
  group,
  resolveData,
  children,
}) => {
  const { visible } = useVisibilityResolve(group.visible, resolveData);

  if (!visible || group.allowVisible === false) {
    return null;
  }

  return <FormGroupFrame caption={group.caption}>{children}</FormGroupFrame>;
};

export default SettingsPanelGroup;
